/*
 |--------------------------------------------------------------------------
 | ShowMore
 |
 | This module adds functionality to the Sitecore and Angular version of
 | the show-more component
 |--------------------------------------------------------------------------
 */

// Constants
const AShowMoreSelector = '.a-show-more';
const AShowMoreListIdAttribute = 'data-show-more-list-id';
const AShowMoreItemsToShowAttribute = 'data-show-more-items-to-show';
const AShowMoreStepAttribute = 'data-show-more-step';
const AShowMoreHiddenClass = 'a-show-more--hidden';
const AShowMoreButtonHiddenClass = 'a-show-more--button-hidden';

// Class
class AShowMore {
  constructor(element) {
    this.element = element;
    this.list = document.getElementById(
      this.element.getAttribute(AShowMoreListIdAttribute)
    );
  }

  init = () => {
    if (!this.element || !this.list || this.list.children.length <= 0) {
      return;
    }

    this.totalItems = this.list.children.length;
    this.itemsToShow = this.list.children.length; // Default to all items

    const itemsToShow = parseInt(
      this.element.getAttribute(AShowMoreItemsToShowAttribute),
      10
    );

    if (itemsToShow || !isNaN(itemsToShow) || itemsToShow > 0) {
      this.itemsToShow = itemsToShow;
    }

    const step = parseInt(
      this.element.getAttribute(AShowMoreStepAttribute),
      10
    );

    if (step || !isNaN(step) || step > 0) {
      this.step = step;
    }

    this.updateList();
    this.checkButtonVisibility();

    this.element.addEventListener('click', (event) => {
      event.preventDefault();
      this.addItems();
      this.updateList();
      this.checkButtonVisibility();
    });
  };

  addItems = () => {
    if (this.step) {
      this.itemsToShow += this.step;
      if (this.itemsToShow > this.totalItems) {
        this.itemsToShow = this.totalItems;
      }
    } else {
      this.itemsToShow = this.totalItems;
    }
  };

  updateList = () => {
    if (!this.list || this.list.children.length <= 0 || !this.itemsToShow) {
      return;
    }

    const listItems = this.list.children;

    for (let i = 0; i < this.totalItems; i++) {
      if (i < this.itemsToShow) {
        listItems[i].classList.remove(AShowMoreHiddenClass);
      } else {
        listItems[i].classList.add(AShowMoreHiddenClass);
      }
    }
  };

  checkButtonVisibility = () => {
    if (this.itemsToShow >= this.totalItems) {
      this.element.classList.add(AShowMoreButtonHiddenClass);
    } else {
      this.element.classList.remove(AShowMoreButtonHiddenClass);
    }
  };
}

// Initiate module
function aShowMoreCreateInstance(element) {
  if (!element.showMoreClass) {
    element.showMoreClass = new AShowMore(element);
    element.showMoreClass.init();
  }
}
document
  .querySelectorAll(`${AShowMoreSelector}`)
  .forEach(aShowMoreCreateInstance);

// Create new ShowMore instances on DOM mutation
const AShowMoreObserver = new MutationObserver(function (mutations) {
  mutations.forEach((mutation) => {
    mutation.addedNodes.forEach((element) => {
      document
        .querySelectorAll(`${AShowMoreSelector}`)
        .forEach(aShowMoreCreateInstance);
    });
  });
});

AShowMoreObserver.observe(document, {
  attributes: false,
  childList: true,
  characterData: false,
  subtree: true,
});
